import Typography from '@mui/material/Typography';
import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './page-section-base.style';

export type PageSectionBaseProps = {
  title?: string;
  url?: string;
  centerInteractions?: React.ReactNode;
  interactions?: React.ReactNode;
  fullSize?: boolean;
  grow?: boolean;
  hasBorder?: boolean;
  noPadding?: boolean;
  children: React.ReactNode;
};

export const PageSectionBase: React.FC<PageSectionBaseProps> = ({
  title,
  url,
  centerInteractions,
  interactions,
  fullSize,
  grow,
  hasBorder,
  noPadding,
  children,
}) => (
  <Styled.Container $fullSize={!!fullSize} $grow={!!grow}>
    {!!title && (
      <Styled.Header $hasBorder={!!hasBorder}>
        <Styled.SideArea>
          <Styled.TitleContainer as={!url ? 'span' : undefined} to={url || ''}>
            <Typography variant="h6" component="h2">
              {title}
            </Typography>

            {!!url && (
              <Styled.ChevronContainer>
                <Icon icon={ChevronLeft} />
              </Styled.ChevronContainer>
            )}
          </Styled.TitleContainer>
        </Styled.SideArea>

        {!!centerInteractions && (
          <Styled.CenterInteractions>
            {centerInteractions}
          </Styled.CenterInteractions>
        )}

        <Styled.SideArea $alignEnd>{interactions}</Styled.SideArea>
      </Styled.Header>
    )}

    <Styled.Body
      $hasTitle={!!title}
      $noPadding={!!noPadding}
      $fill={!!grow && !fullSize}
    >
      {children}
    </Styled.Body>
  </Styled.Container>
);
